<template>
  <div class="dev-commissioner-detail">
    <el-card class="dev-commissioner-info mb15" v-loading="loadingForm">
      <div slot="header" class="clearfix">
        <span class="fl">发展专员信息</span>
        <div class="fr"><el-button size="mini" type="link" @click="$router.go(-1)">返回</el-button></div>
      </div>
      <el-form :inline="true" :label-position="'right'" label-width="110px">
        <el-form-item label="姓名">
          <div class="w200">{{ form.developerName }}</div>
        </el-form-item>
        <el-form-item label="手机号">
          <div class="w200">{{ form.phoneNumber }}</div>
        </el-form-item>
        <el-form-item label="部门">
          <div class="w200">{{ form.department }}</div>
        </el-form-item>
        <el-form-item label="加盟日期">
          <div class="w200">{{ form.createTime }}</div>
        </el-form-item>
        <el-form-item label="状态">
          <div class="w200">{{ form.state === 0 ? '有效' : (form.state === 1 ? '无效' : '') }}</div>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <div class="opreationBox" style="margin-bottom: 10px;">
        <el-form
          size="mini"
          :inline="true"
          :model="params"
          label-width="140px"
          class="demo-form-inline"
          @submit.native.prevent
        >
          <!--<el-form-item label="战略合伙人编号">
            <el-input placeholder="请输入" clearable v-model="params.code" />
          </el-form-item>-->
          <el-form-item label="战略合伙人名称">
            <el-input placeholder="请输入" clearable v-model="params.enterpriseName" />
          </el-form-item>
          <el-form-item label="战略合伙人生效状态">
            <el-select
              clearable
              placeholder="全部"
              v-model="params.state"
            >
              <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button style="width:98px" type="primary" @click="search">查 询</el-button>
            <el-button style="width:98px" type="danger" plain @click="reset">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableBox">
        <el-table
          border
          size="mini"
          :data="data"
          v-loading="loading"
          style="width: 100%"
        >
<!--          <el-table-column label="战略合伙人编号" align="center" prop="code" />-->
          <el-table-column label="战略合伙人名称" align="center" prop="enterpriseName" />
          <el-table-column label="战略合伙人(负责人手机号)" align="center" prop="phoneNumber" />
          <el-table-column label="负责人姓名" align="center" prop="enterpriseManager" />
          <el-table-column label="加盟日期" align="center" prop="createTime" />
          <el-table-column label="状态" align="center" width="120" prop="state">
            <template slot-scope="scope">
              {{ scope.row.state === 0 ? '有效' : ( scope.row.state === 1 ? '无效' : '') }}
            </template>
          </el-table-column>
          <el-table-column label="二级合伙人数量" align="center" prop="partnerCount" />
          <el-table-column label="会员数量" align="center" prop="panelCount" />
          <el-table-column label="会员关注数量" align="center" prop="panelFocusCount" />
          <el-table-column label="操作" min-width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                plain
                size="mini"
                @click="look(scope.row)"
                style="margin-bottom: 10px;"
              >
                详情
              </el-button>
              <el-button
                plain
                size="mini"
                @click="download('战略合伙人业绩表', scope.row)"
                type="primary"
                style="margin-bottom: 10px;"
              >
                战略合伙人业绩表
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pageBox" style="margin-top: 10px;width: 100%;text-align: right;">
        <el-pagination
          background
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="params.pageIndex"
          :page-sizes="[2, 4, 10, 20, 50, 100]"
          :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
    <downloadDialog ref="downloadDialog" />
  </div>
</template>

<script>
  import { getDevManagerDetail as getList, enterpriseDownloadPerformance } from 'api/request'
  import downloadDialog from "@/components/downloadDialog"
  export default {
    name: 'DevCommissionerDetail',
    components: {
      downloadDialog
    },
    data() {
      return {
        loadingForm: false,
        loading: false,
        params: {
          developerId: this.$route.query.id,
          pageIndex: 1,
          pageSize: 10,
          code: undefined,
          enterpriseName: undefined,
          state: undefined
        },
        stateList: [
          { value: '0', label: '有效' },
          { value: '1', label: '无效' }
        ],
        data: [],
        total: 0,
        form: {},
        acTabName: '0',
      }
    },
    mounted() {
      this.getList(true)
    },
    methods: {
      async getList(isFirst) {
        this.loading = true
        if (isFirst) {
          this.loadingForm = true
        }
        const res = await getList(this.params)
        if (res) {
          this.form = res
          const { rows, total } = res
          this.data = Array.isArray(rows) ? rows : []
          this.total = total && total > 0 ? total : 0
        }
        this.loading = false
        this.loadingForm = false
      },
      sizeChange(val) {
        this.params.pageSize = val
        this.getList()
      },
      currentChange(val) {
        this.params.pageIndex = val
        this.getList()
      },
      search() {
        this.params.pageIndex = 1
        this.getList()
      },
      reset() {
        Object.assign(this.$data.params, this.$options.data().params)
        this.getList()
      },
      look(row) {
        const { enterpriseId } = row
        this.$router.push({ path: '/enterpriseDetail', query: { id: enterpriseId }})
      },
      download(title, data) {
        const { id } = data
        const downloadParams = { enterpriseId: id}
        const apiQueryStr = Object.keys(downloadParams).map(v => `&${v}=${downloadParams[v]}`).join('')
        this.$refs.downloadDialog.show({ api: enterpriseDownloadPerformance, apiQueryStr, title: title })
      },
    }
  }
</script>

<style scoped lang="scss">
  .dev-commissioner-detail{
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
    .mb15{
      margin-bottom: 15px;
    }
    .dev-commissioner-info{
      .el-form{
        .el-form-item{
          margin-bottom: 0;
        }
      }
    }
    .w200{
      width: 200px;
    }
  }
</style>

